import {
  IBenefitCheckoutRequest,
  IJobBenefitOption,
} from '../../services/servicePostAJob/responseInterfaces';

interface IBenefitCheckoutBodyInput {
  siteId: string;
  listingType: number;
  organizationId?: number;
  couponCode?: string;
  contactEmail?: string | null;
  draftGuid?: string;
  existingClaimCheckoutGuid?: string;
  existingClaimContactEmail?: string;
  option: IJobBenefitOption;
}

/** Keep source identifiers explicit so quote output cannot be confused with authority. */
export const buildBenefitCheckoutBody = ({
  siteId,
  listingType,
  organizationId,
  couponCode,
  contactEmail,
  draftGuid,
  existingClaimCheckoutGuid,
  existingClaimContactEmail,
  option,
}: IBenefitCheckoutBodyInput): IBenefitCheckoutRequest => ({
  siteId,
  listingType,
  ...(organizationId ? { organizationId } : {}),
  ...(couponCode ? { couponCode } : {}),
  ...(contactEmail ? { contactEmail } : {}),
  ...(option.benefitRuleId ? { benefitRuleId: option.benefitRuleId } : {}),
  ...(option.couponId ? { couponId: option.couponId } : {}),
  ...(option.subscriptionId ? { subscriptionId: option.subscriptionId } : {}),
  ...(option.subscriptionPaymentId ? { subscriptionPaymentId: option.subscriptionPaymentId } : {}),
  ...(draftGuid ? { draftGuid } : {}),
  ...(existingClaimCheckoutGuid ? { existingClaimCheckoutGuid } : {}),
  ...(existingClaimContactEmail ? { existingClaimContactEmail } : {}),
});
